/**
 * PATH: apps/assets/src/pages/ReportsPage.tsx
 * PURPOSE: Asset reports and analytics
 */
import { EmptyRegister } from './emptyRegister'

export default function ReportsPage() {
  return (
    <EmptyRegister
      title="Reports"
      detail="No asset reports are connected."
    />
  )
}
